var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3803 6.45704L5.95173 6.45704C3.91298 6.45704 2.29102 8.05857 2.29102 9.99673C2.29102 11.6675 3.49392 13.0862 5.13393 13.4479C5.39627 13.5057 5.66991 13.5364 5.95173 13.5364C6.29691 13.5364 6.57673 13.8162 6.57673 14.1614C6.57673 14.5066 6.29691 14.7864 5.95173 14.7864C5.5789 14.7864 5.21502 14.7458 4.86477 14.6686C2.68766 14.1885 1.04102 12.29 1.04102 9.99673C1.04102 7.3347 3.25662 5.20704 5.95173 5.20704L7.3803 5.20704C10.0838 5.20704 12.291 7.57856 12.291 9.99673C12.291 10.3419 12.0112 10.6217 11.666 10.6217C11.3208 10.6217 11.041 10.3419 11.041 9.99673C11.041 8.26202 9.3866 6.45704 7.3803 6.45704Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6184 13.5364L14.047 13.5364C16.0857 13.5364 17.7077 11.9349 17.7077 9.99672C17.7077 8.32597 16.5048 6.9072 14.8648 6.54557C14.6024 6.48772 14.3288 6.45703 14.047 6.45703C13.7018 6.45703 13.422 6.17721 13.422 5.83203C13.422 5.48685 13.7018 5.20703 14.047 5.20703C14.4198 5.20703 14.7837 5.24766 15.1339 5.32489C17.311 5.80495 18.9577 7.70345 18.9577 9.99672C18.9577 12.6587 16.7421 14.7864 14.047 14.7864L12.6184 14.7864C9.91487 14.7864 7.70768 12.4149 7.70768 9.99672C7.70768 9.65154 7.9875 9.37172 8.33268 9.37172C8.67786 9.37172 8.95768 9.65154 8.95768 9.99672C8.95768 11.7314 10.6121 13.5364 12.6184 13.5364Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.aa1b5ea7047abc3c1c7e2a4953bb0f4e.svg";
export { ForwardRef as ReactComponent };